import { render } from "./RequestPasswordReset.vue?vue&type=template&id=33a9d81f&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"

import "./RequestPasswordReset.vue?vue&type=style&index=0&id=33a9d81f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a9d81f"]])

export default __exports__